import { useState } from 'react';
import { setIsAnyModalOpen } from '../../../../redux/reducers/controllNavigation';
import { useDispatch } from 'react-redux';

export type LoadingStatus = 'idle' | 'loading' | 'success' | 'error' | 'empty-export';

export const useLoadingModal = () => {
  const [status, setStatus] = useState<LoadingStatus>('idle');
  const [downloadCallback, setDownloadCallback] = useState<(() => void) | null>(null);
  const dispatch = useDispatch()

  const showLoading = () => setStatus('loading');
  const showSuccess = () => setStatus('success');
  const showError = () => setStatus('error');
  const showEmptyExport = (callback: () => void) => {
    setStatus('empty-export');
    setDownloadCallback(() => callback);
  };
  const close = () => {
    dispatch(setIsAnyModalOpen(false));
    setStatus('idle');
    setDownloadCallback(null);
  };

  const executeWithLoading = async <T>(
    asyncFunction: () => Promise<T>
  ): Promise<T | null> => {
    try {
      showLoading();
      const result = await asyncFunction();
      showSuccess();
      return result;
    } catch (error) {
      showError();
      return null;
    }
  };

  return {
    status,
    isOpen: status !== 'idle',
    downloadCallback,
    showLoading,
    showSuccess,
    showError,
    showEmptyExport,
    close,
    executeWithLoading,
  };
};